import React from "react";
// import { RHFToggleButtonGroup } from "../../molecules/rhfToggleButtonGroup";
// import { Section } from "../../particles/layout/section";
// import { LabelTooltip } from "../labelTooltip";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

//** TEST */
import { Section, LabelTooltip } from "@arp/react-ndbx";
import { RHFToggleButtonGroup } from "../rhfToggleButtonGroup";

//----------------------------------------------------------------
export default function RHFCircleToggleGroupLabelled({ sx = [], ...props }) {
  const {
    name = "",
    label = "",
    exclusive = true,
    items = [],
    error = false,
    showTooltip = false,
    tooltipText = "ADD TOOLTIP",
    marginBottom = 1,
    alignTooltip = "flex-start",
    description,
    position = "center",
    minHeight = 50,
    labelVariant = "label-large-bold",
  } = props;
  const { text } = { ...label };
  return (
    <Stack
      direction="column"
      display="flex"
      justifyContent="flex-start"
      alignItems="flex-start"
      sx={{
        // maxWidth: "474px",
        // width: "100%",
        mt: 0,
        padding: 0,
      }}
      xs={12}
    >
      <Section
        mt={0}
        mb={{ xs: 2, md: 0 }}
        xs={12}
        md={12}
        sx={{ outline: "0px green solid" }}
      >
        <Stack
          direction="row"
          width="100%"
          mb={marginBottom}
          sx={{
            justifyContent: position ? position : "center",
            alignItems: { alignTooltip },
            // outline: "1px red solid",
          }}
        >
          {/* Pass in 0 if you want to remove this setting */}
          <Box
            sx={{ minHeight: minHeight }}
            textAlign={position ? position : "center"}
            xs={2}
          >
            {/* <Box> */}
            <Typography
              sx={{
                width: "fit-content !important",
              }}
              mb={0}
              variant={labelVariant}
            >
              {text}
            </Typography>
          </Box>
          <Box>
            {showTooltip ? (
              <LabelTooltip
                controlIdentifier={`${name}-toggle-group-label-tooltip`}
                tooltipTitle={tooltipText}
              />
            ) : null}
          </Box>
        </Stack>
        {description && (
          <Box mb={{ xs: 5 }} textAlign={position ? position : "center"}>
            <Typography variant="p3">{description}</Typography>
          </Box>
        )}
      </Section>
      <Section mt={0} mb={0}>
        <RHFToggleButtonGroup
          variant="circle-group"
          exclusive={exclusive}
          name={name}
          items={items}
          sx={{ mt: 0 }}
          error={error}
          position={position}
          {...props}
        ></RHFToggleButtonGroup>
      </Section>
    </Stack>
  );
}
